import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function TenantSelectionModal({ open, tenants, onSelect, loading }) {
  const [selectedId, setSelectedId] = useState(null);

  const handleConfirm = () => {
    if (selectedId != null) {
      onSelect(selectedId);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      slotProps={{ backdrop: { onClick: (e) => e.stopPropagation() } }}
    >
      <DialogTitle>Select a Tenant</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Your account has access to multiple tenants. Please select the one you want to work with.
        </Typography>
        <List disablePadding>
          {(tenants || []).map((t) => (
            <ListItemButton
              key={t.id}
              selected={selectedId === t.id}
              onClick={() => setSelectedId(t.id)}
              sx={{
                borderRadius: 1,
                mb: 0.5,
                border: '1px solid',
                borderColor: selectedId === t.id ? 'primary.main' : 'divider',
              }}
            >
              <ListItemText primary={t.tenantName} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Box sx={{ position: 'relative' }}>
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={selectedId == null || loading}
          >
            Continue
          </Button>
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px',
              }}
            />
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
}
